import AccountApi from '@/api/account'
import PresentationApi from '@/api/presentation'
import UserApi from '@/api/user'
import FolderApi from '@/api/folder'
import SlideApi from '@/api/slide'
import StripeApi from '@/api/stripe'
import PricingApi from '@/api/pricing'
import AnswerApi from '@/api/answer'
import SlideOptionApi from '@/api/slideOption'
import StickerApi from '@/api/sticker'
import AuthApi from '@/api/auth'
import InvitationApi from '@/api/invitation'
import InvoiceApi from '@/api/invoice'
import ChatApi from '@/api/chat'
import templateApi from '@/api/template'
import searchApi from '@/api/search'
import promoApi from '@/api/promo'
import planApi from '@/api/plan'
import communityApi from '@/api/community'
import categoryApi from '@/api/category'
import opentokApi from '@/api/opentok'
import audienceAuthenticationApi from '@/api/audienceAuthentication'

const initResources = () => {
  AccountApi.initResource()
  PresentationApi.initResource()
  UserApi.initResource()
  FolderApi.initResource()
  SlideApi.initResource()
  StripeApi.initResource()
  PricingApi.initResource()
  AnswerApi.initResource()
  SlideOptionApi.initResource()
  StickerApi.initResource()
  AuthApi.initResource()
  InvitationApi.initResource()
  InvoiceApi.initResource()
  ChatApi.initResource()
  templateApi.initResource()
  searchApi.initResource()
  promoApi.initResource()
  planApi.initResource()
  communityApi.initResource()
  categoryApi.initResource()
  opentokApi.initResource()
  audienceAuthenticationApi.initResource()
}

export default {
  initResources,
}
